// @ts-nocheck
/* eslint-disable */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-floating-promises */
import React, { useEffect, useRef, useState } from 'react';
import {
  Button,
  Form,
  Input,
  Message,
  Modal,
  Popconfirm,
  Select,
  Space,
  Switch,
  Table,
  TableColumnProps
} from '@arco-design/web-react';
import { getNoticeList, deleteNoticeById } from '../service/announcement'
import { post } from '../requestNew';

import dayjs from 'dayjs';

import './index.scss';
import { Item } from './types';

const FormItem = Form.Item;
const TextArea = Input.TextArea;
const Option = Select.Option;

const formItemLayout = {
  labelCol: {
    span: 6
  },
  wrapperCol: {
    span: 16
  }
};

function Announcement() {
  const [form] = Form.useForm<Item>();
  const [formSearch] = Form.useForm<Item>();
  const [visible, setVisible] = useState(false);
  const [pageSize, setPageSize] = useState(20);
  const [pageNum, setPageNum] = useState(1);
  const [total, setTotal] = useState(0);
  const [dataList, setDataList] = useState<Item[]>([]);

  const formRef = useRef<any>({});

  const columns: TableColumnProps[] = [
    {
      title: '序号',
      width: 50,
      render: (_, record, i) => i + 1
    },
    {
      title: '内容',
      dataIndex: 'notice',
      width: 300
    },
    {
      title: '发布时间',
      dataIndex: 'createTime',
      width: 130,
      render: text => dayjs(text).format('YYYY-MM-DD')
    },
    {
      title: '公告类型',
      dataIndex: 'type',
      width: 100,
      render: (text, record) => {
        if (text === 1) {
          return '关注公告';
        } else if (text === 2) {
          return '推荐公告';
        } else if (text === 3) {
          return '广场公告';
        } 
        return '-';
      }
    },
    {
      title: '是否显示',
      dataIndex: 'isDisplay',
      width: 100,
      render: (text, record) => <Switch checked={text === 1} onChange={val => displayChange(val, record)} />
    },
    {
      title: '操作',
      dataIndex: 'action',
      width: 120,
      render: (_, record: Item) => (
        <>
          <Button className="btn" type="text" onClick={() => edit(record)}>
            编辑
          </Button>
          <Popconfirm focusLock title="提示" content="是否确认删除?" onOk={() => del(record)}>
            <Button className="btn" type="text" status="danger">
              删除
            </Button>
          </Popconfirm>
        </>
      )
    }
  ];


  const getList = (reset?: boolean) => {

    if (reset) {
      setPageNum(1);
      setPageSize(20);
    }

    const params = {
      ...formSearch.getFieldsValue(),
      pageNum,
      pageSize
    };
    getNoticeList(params, (data: any) => {
      const { list, total } = data;
      setTotal(total);
      setDataList(list || []);
    });
  };

  const handleReset = () => {
    formSearch.resetFields();
    setPageNum(1);
    setPageSize(20);
    const params = {
      pageNum: 1,
      pageSize: 20
    };
    getNoticeList(params, (data: any) => {
      const { list, total } = data;
      setTotal(total);
      setDataList(list || []);
    });
  };

  const add = () => {
    formRef.current = {};
    form.resetFields();
    setVisible(true);
  };
  const del = (record: Item) => {
    post(`/notice/delete?id=${record.id}`)
      .then((res: any) => {
        const { code, message } = res || {};
        if (code === 200) {
          Message.success('删除成功！');
          getList();
        } else {
          Message.error(message);
        }
      })
      .catch(() => {
        Message.error('网络错误!');
      });
  };

  const displayChange = (val: boolean, record: Item) => {
    const isDisplay = val ? 1 : 0;
    post(`/notice/update`, { ...record, isDisplay })
      .then((res: any) => {
        const { code, message } = res || {};
        if (code === 200) {
          getList();
        } else {
          Message.error(message);
        }
      })
      .catch(() => {
        Message.error('网络错误!');
      });
  };

  const edit = (record: Item) => {
    formRef.current = record;
    form.setFieldsValue({ ...record, isShow: record.isDisplay === 1, type: record.type });
    setVisible(true);
  };
  const editCancel = () => {
    formRef.current = {};
    setVisible(false);
    form.resetFields();
  };
  const onOk = () => {
    const { isShow, notice, type } = form.getFieldsValue();
    if (!notice) {
      Message.error('请输入正文!');
      return;
    }
    if (!type) {
      Message.error('请选择公告类型!');
      return;
    }

    const data = {
      ...formRef.current,
      notice,
      isDisplay: isShow ? 1 : 0,
      type
    };
    const url = formRef.current.id ? `/notice/update` : `/notice/add`;
    post(url, data)
      .then((res: any) => {
        const { code, message } = res || {};
        if (code === 200) {
          getList();
          editCancel();
        } else {
          Message.error(message);
        }
      })
      .catch(e => {
        Message.error('网络错误!');
        console.log(e);
      });
  };

  useEffect(() => {
    getList();
  }, [pageNum, pageSize]);

  return (
    <div className="announcement table-flex">
      <Space style={{ flexWrap: 'wrap' }}>
        <Form style={{ width: '100%' }} autoComplete="off" layout="inline" form={formSearch}>
          <FormItem label="公告内容" field="notice">
            <Input style={{ width: 200 }} />
          </FormItem>
          <FormItem label="是否展示" field="isDisplay">
            <Select style={{ width: 100 }} allowClear>
              <Option value={0}>否</Option>
              <Option value={1}>是</Option>
            </Select>
          </FormItem>
          <FormItem>
            <Button type="primary" onClick={() => getList(true)}>
              查询
            </Button>
          </FormItem>
          <FormItem>
            <Button type="outline" onClick={handleReset}>
              重置
            </Button>
          </FormItem>
          <FormItem>
            <Button className="filter-item" type="primary" onClick={add}>
              新增
            </Button>
          </FormItem>
        </Form>
      </Space>
      <div className="table-content">
        <Table
          rowKey="id"
          columns={columns}
          data={dataList}
          className="table-scroll"
          pagination={{
            sizeCanChange: true,
            pageSize,
            total,
            showTotal: true,
            current: pageNum,
            onChange: (num, size) => {
              setPageNum(num);
              if (size && size !== pageSize) {
                setPageSize(size);
              }
            }
          }}
          scroll={{ y: '100%', x: '100%' }}
        />
      </div>
      <Modal
        title={formRef.current.id ? '编辑' : '新增'}
        visible={visible}
        onCancel={editCancel}
        onOk={onOk}
        unmountOnExit
      >
        <Form {...formItemLayout} form={form}>
          <FormItem label="正文" field="notice">
            <TextArea placeholder="" />
          </FormItem>
          <FormItem label="公告类型" field="type">
            <Select placeholder="请选择公告类型">
              <Option value={1}>关注公告</Option>
              <Option value={2}>推荐公告</Option>
              <Option value={3}>广场公告</Option>
            </Select>
          </FormItem>
          <FormItem label="是否展示" field="isShow" triggerPropName="checked">
            <Switch />
          </FormItem>
        </Form>
      </Modal>
    </div>
  );
}

export default Announcement;
